import React, { useEffect, useState } from 'react';
import { Quote } from 'lucide-react';

const QUOTES = [
  {
    text: 'SAMANVAI helped us connect commercial growth, engineering, quality and operations into one CEO agenda. It moved the conversation from isolated improvement ideas to a focused 100-day roadmap with measurable decision gates.',
    org: 'Specialized Manufacturer & Supplier for Oil Field Products',
    sector: 'Industrial & Energy',
    accent: '#34d399',
  },
  {
    text: 'SAMANVAI gave us enterprise-wide visibility that conventional dashboards and isolated analytics tools could not provide. It separated facts, benchmarks, assumptions and evidence gaps — then translated them into board priorities, risk actions and a transformation roadmap.',
    org: 'Financial Research & Consulting Firm',
    sector: 'Financial Services',
    accent: '#60a5fa',
  },
  {
    text: 'SAMANVAI reframed a complex growth story into a clear CEO agenda linking recovery, competitive moat, market opportunity and cash discipline. The output was practical, evidence-led and immediately usable for executive discussion.',
    org: 'Leading Laboratory Equipment Manufacturer',
    sector: 'Life Sciences & MedTech',
    accent: '#fbbf24',
  },
];

export const HeroQuotes = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const t = setInterval(() => setIndex((p) => (p + 1) % QUOTES.length), 7500);
    return () => clearInterval(t);
  }, [paused]);

  const q = QUOTES[index];

  return (
    <div
      className="relative mb-6"
      data-testid="hero-quotes"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="flex items-center gap-2 mb-3 pl-1 text-[10px] tracking-[0.3em] font-bold uppercase text-white/60">
        <Quote className="w-3 h-3 text-amber-300" />
        In their words
        <span className="text-white/25 mx-1">·</span>
        Outcomes CXOs signed off on
      </div>

      <div className="relative overflow-hidden rounded-2xl bg-white/[0.045] backdrop-blur-md ring-1 ring-white/12 shadow-xl shadow-black/25">
        <span
          className="absolute left-0 top-0 bottom-0 w-[3px] transition-colors duration-700"
          style={{ backgroundColor: q.accent }}
        />
        <div className="pointer-events-none absolute -top-10 -right-10 w-36 h-36 rounded-full opacity-[0.07] blur-2xl transition-colors duration-700" style={{ backgroundColor: q.accent }} />

        <div key={index} className="relative px-6 sm:px-7 pt-5 pb-4 hero-quote-slide">
          <span className="block font-serif leading-none select-none text-[40px] -mb-4 transition-colors duration-700" style={{ color: q.accent }}>
            &ldquo;
          </span>
          <blockquote
            className="font-serif italic text-white/90 text-[14.5px] sm:text-[15.5px] leading-relaxed min-h-[110px] sm:min-h-[96px]"
            data-testid="hero-quote-text"
          >
            {q.text}
          </blockquote>

          <div className="flex flex-wrap items-end justify-between gap-3 mt-4 pt-3.5 border-t border-white/10">
            <div data-testid="hero-quote-attribution">
              <div className="text-[11px] tracking-[0.16em] uppercase font-bold text-white/85">{q.org}</div>
              <div className="text-[10.5px] mt-0.5 transition-colors duration-700" style={{ color: q.accent }}>
                {q.sector}
              </div>
            </div>
            <div className="flex items-center gap-1.5 pb-0.5">
              {QUOTES.map((item, i) => (
                <button
                  key={item.org}
                  type="button"
                  aria-label={`Show quote ${i + 1}`}
                  data-testid={`hero-quote-dot-${i}`}
                  onClick={() => setIndex(i)}
                  className="h-1.5 rounded-full transition-all duration-500"
                  style={{
                    width: i === index ? 22 : 6,
                    backgroundColor: i === index ? item.accent : 'rgba(255,255,255,0.22)',
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes heroQuoteSlide {
          0%   { opacity: 0; transform: translateY(10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .hero-quote-slide { animation: heroQuoteSlide 0.65s cubic-bezier(.2,.7,.2,1) both; }
      `}</style>
    </div>
  );
};

export default HeroQuotes;
